export default "__VITE_ASSET__oCNjH4My__"